import React, { useState, useEffect} from 'react';

import { Document, Page, pdfjs } from 'react-pdf';

import { Container, ButtonGroup } from './styles';
import Menu from "../../components/UI/Menu";
import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import FullScreenLoading from "../../components/UI/FullScreenLoading";
import ReadMoreButton from "../../components/UI/ReadMoreButton"
import Modal from "../../components/UI/Modal";

import Banner from '../../components/UI/Banner';

import useApi from "../../hooks/useApi";
// import QrCodeScanner from "./Html5QrcodeScanner"

import QrScanner from 'qr-scanner';

const CourseRegisterQRCode = () => { 
  const [qrResult, setQrResult] = useState({});
  const [qrCapture, setQrCapture] = useState("");
  const [qrError, setQrError] = useState("");
  const [documento, setDocumento] = useState({});
  const [activity, setActivity] = useState({});
  const [subscribe, setSubscribe] = useState({});
  const [userActivity, setUserActivity] = useState([]);
  const [activitiesRights, setActivitiesRights] = useState({tutor:false,editor:false,inscrito:false,load:false});

  /* Define Worker para trabalhar com o arquivo PDF  ---- inicio*/
  pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url
  ).toString();
  /* Define Worker para trabalhar com o arquivo PDF  ---- fim*/

  /*codigo para comprimir a imagem e remover linhas brancas que podem aparecer ao gerar a imagem apartir do pdf*/
  
  const [imgSrc, setImgSrc] = useState(null);

  // Função executada quando o canvas invisível termina de desenhar o PDF
  const aoRenderizarComSucesso = () => {
    // Captura o canvas interno do react-pdf
    const canvas = document.querySelector('.canvas-escondido canvas');
    if (canvas) {
      // Transforma o canvas em uma imagem real PNG (Base64)
      const imagemBase64 = canvas.toDataURL('image/png');
      setImgSrc(imagemBase64);
    }
  };

  /* fim */

  const [loadDocument, loadDocumentInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/course",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        if(response.data.length>0){
          setDocumento(response.data[0]);
        }
      }
    },
  });

  const [listActivities, ListActivitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/activities",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        setActivity(response.data.filter((temp)=>{return temp.idContentActivity===qrResult?.activity})[0]);
      }
    },
    onError:(error)=>{
      console.log("error", error);
    },
  });

  const [listSubscribe, ListSubscribeInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/subscription/v2",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        setSubscribe(response.data.filter((temp)=>{return temp.idUserSubscription===qrResult?.idUserSubscription})[0]);
      }
    },
    onError: (error)=>{ 
      // document.location.reload(false);
    },
  });

  const [loadListUserActivities, LoadListUserActivitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/userActivities/course",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        setUserActivity(
          response.data.filter((temp)=>{
            return temp.iduser_subscription===qrResult?.idUserSubscription && 
                   temp.idcontent_activity===qrResult?.activity && 
                   temp.hours_taken!==null}));
      }
    },
    onError: (error)=>{ 
      // document.location.reload(false);
    },
  });
  const [loadRights, loadRightsInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/course/activities/coursesByUser",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("course by user", response.data[0]);
        if(response.data.length>0){
          setActivitiesRights({tutor:response.data[0].isTutor,editor:response.data[0].isEditor,inscrito:response.data[0].isRegistered,load:true});
        }
      }
    },
    onError:(error)=>{
      console.log("error", error);
    },
  });

  const [postUserActivities, postUserActivitiesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/userActivities",
    method: "post",
    onCompleted: (response) => {
      if (!response.error) {
        loadListUserActivities({
          params: {
            idContent:qrResult.course,
          },
        });
      }
    },
    onError: (error)=>{ 
      // document.location.reload(false);
    },
  });

  const postActivity = (data)=>{
    postUserActivities({data});
  };

  function isBase64(str) {
    if (typeof str !== 'string') return false;
    
    // Regex para validar a estrutura e os caracteres do Base64
    const regexBase64 = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
    
    return regexBase64.test(str);
  }

  const onScanSuccess = (decodedText, decodedResult) => {
    setQrCapture(decodedText);

  };
  
  useEffect(() => {
      console.log("capturado",qrCapture);
      if(isBase64(qrCapture)){
        let temp = JSON.parse(atob(qrCapture));
        setQrResult(temp);
        qrScanner?.stop();
      }
      else{
        console.log("lixo?",qrCapture);
      }
      //eslint-disable-next-line
    }, [qrCapture]);


  let qrScanner;

  useEffect(() => {
    document.getElementsByClassName("enabled")[0].style.display = "none";
    qrScanner = new QrScanner(
      document.getElementById("qrcode"),
      result => {
        setQrCapture(result.data);
      },
      {onDecodeError: error => {}, highlightScanRegion: true, maxScansPerSecond:5}
    );
    // $(".enabled").hide();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if(qrResult.course){
      loadDocument({
        params: {
          id:qrResult.course,
        },
      });
      listActivities({
        params: {
          idContent:qrResult.course,
        },
      });
      listSubscribe({
        params: {
          id:qrResult.course,
        },
      });
      loadListUserActivities({
        params: {
          idContent:qrResult.course,
        },
      });
      loadRights({
        params:{
          id:qrResult.course,
        }
      });
    }
    //{idUserSubscription,course,activity}

    //eslint-disable-next-line
  }, [qrResult]);

  return (
    <Container>
      {(loadDocumentInfo.loading ||
        ListActivitiesInfo.loading ||
        ListSubscribeInfo.loading ||
        LoadListUserActivitiesInfo.loading ||
        loadRightsInfo.loading ||
        postUserActivitiesInfo.loading
      ) && (
        <FullScreenLoading />
      )}
      <Menu accessibilityIcon={false}/>
      <Banner>
        Meus Testes
      </Banner>
      <ContentBox>

      {/* Thumbnail */}

      thumbnail com alteção na renderização
      <div style={{ 
      display: 'inline-block',
      padding: '6px',
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0'
      }}>
      
        {/* Se a imagem real já foi gerada, exibe ela (onde o navegador esconde as linhas) */}
        {imgSrc ? (
          <img 
            src={imgSrc} 
            alt="Miniatura do PDF" 
            style={{ 
              width: '360px', //define o tamanho da miniatura
              height: 'auto', 
              display: 'block',
              borderRadius: '4px',
              // Filtro do navegador que força a fusão das fatias coloridas na imagem
              imageRendering: 'auto' 
            }} 
          />
        ) : (
          <div>Carregando miniatura...</div>
        )}

        {/* CANVAS INVISÍVEL: Roda em segundo plano apenas para gerar a imagem */}
        <div className="canvas-escondido" style={{ display: 'none' }}>
          <Document file={"https://storage-comunidades.sme-mogidascruzes.sp.gov.br/files/canalPedagogico/documents/documents_203cd7f3-abb9-44b5-9460-91a06a9df5ac.pdf"}>
            <Page 
              pageNumber={1} 
              width={2048} // Renderiza com o dobro do tamanho para a imagem final ter alta nitidez (Melhora a Nitidez)
              renderTextLayer={false} 
              renderAnnotationLayer={false}
              onRenderSuccess={aoRenderizarComSucesso}
            />
          </Document>
        </div>

      </div>

      thumbnail sem alterar renderização
      <div style={{ padding: '20px' }}>
      
        <div style={{ border: '1px solid #ccc', display: 'inline-block', padding: '5px', borderRadius: '4px' }}>
          <Document 
            file={"https://storage-comunidades.sme-mogidascruzes.sp.gov.br/files/canalPedagogico/documents/documents_203cd7f3-abb9-44b5-9460-91a06a9df5ac.pdf"} 
            loading={<div>Carregando miniatura...</div>}
            error={<div>Erro ao carregar o PDF.</div>}
          >
            <Page 
              pageNumber={1} 
              width={360} 
              renderTextLayer={false} 
              renderAnnotationLayer={false} 
            />
          </Document>
        </div>
      </div>

      {/* Thumbnail */}
        
        {/* <QrCodeScanner 
          fps={10}
          qrbox={{width: 250, height: 250}}
          disableFlip={false}
          qrCodeSuccessCallback={onScanSuccess}
          qrCodeErrorCallback={(error)=>{console.log("erro ao scannear: ",error)}}
          pause={qrCapture!==""}
        /> */}

        <video id="qrcode"></video>

        <ReadMoreButton text={"Start"} onClick={()=>{qrScanner?.start();}} />
        <ReadMoreButton text={"Reload Page"} onClick={()=>{window.location.reload();}} />

        <Modal open={qrCapture!==""} buttonClose = {false}>
          {qrError && <div>ERRO: {qrError}</div>}
          {(activitiesRights.tutor || activitiesRights.editor) ? <>
            <p>{documento?.title}</p>
            <p>Atividade:{activity?.title}</p>
            <p>Cursista:{subscribe?.name}</p>
          </> : 
          <p>Não é tutor ou editor de {documento.title} para fazer registro de presença</p>}
          {userActivity.length>0 && <p>Presença na atividade registrada</p>}
          <ButtonGroup>
            <ReadMoreButton text={"Fechar"} onClick={()=>{setQrResult([]);setQrError("");setQrCapture("");}}/>
            {userActivity.length===0 && (activitiesRights.tutor || activitiesRights.editor) && 
              <ReadMoreButton text={"Registrar Presença"} 
                              onClick={()=>{
                                postActivity({
                                  activityScore:activity.activityWorkload,
                                  idUserSubscription:subscribe.idUserSubscription,
                                  idContentActivity:activity.idContentActivity,
                                  hoursTaken:1,
                                })
                              }} />}
          </ButtonGroup>
        </Modal>
        
      </ContentBox>
      <Footer />
    </Container>
  );
}

export default CourseRegisterQRCode;
